export default __webpack_public_path__ + "static/media/pagcor.b687ed68.svg";